/*
 * This component is copied from Backstage 1.8.2.
 * CHANGES:
 * - Added custom UI
 */

import { useEntityList } from '@backstage/plugin-catalog-react';
import { FC, useEffect, useMemo, useState } from 'react';
import { EnumFilter } from '../WbTableFilters';
import { EntityErrorFilter, EntityOrphanFilter } from './utils';

export const EntityProcessingStatusPicker: FC = () => {
  const {
    updateFilters,
    queryParameters: { orphan: orphanParameter, error: errorParameter },
  } = useEntityList();

  const initialFilterState = useMemo(
    () => [
      ...(orphanParameter ? ['Is Orphan'] : []),
      ...(errorParameter ? ['Has Error'] : []),
    ],
    [orphanParameter, errorParameter],
  );

  const [selectedAdvancedItems, setSelectedAdvancedItems] =
    useState<string[]>(initialFilterState);

  useEffect(() => {
    const isOrphan = selectedAdvancedItems.includes('Is Orphan');
    const hasError = selectedAdvancedItems.includes('Has Error');

    updateFilters({
      orphan: isOrphan ? new EntityOrphanFilter(true) : undefined,
      error: hasError ? new EntityErrorFilter(true) : undefined,
    });
  }, [selectedAdvancedItems, updateFilters]);

  const availableAdvancedItems = ['Is Orphan', 'Has Error'];

  return (
    <EnumFilter<string>
      value={selectedAdvancedItems}
      options={availableAdvancedItems}
      renderOption={o => o}
      renderValue={v => v}
      field="Processing status"
      onChange={v => {
        const value = v || [];
        setSelectedAdvancedItems(value);
      }}
      onSearch={v =>
        availableAdvancedItems.filter(o => new RegExp(v, 'ig').test(o))
      }
    />
  );
};
